import React, { useState, useEffect } from 'react';
import { Greeting } from './Greeting';
import { KPIGrid } from './KPIGrid';
import { QuickActionsGrid } from './QuickActionsGrid';
import { ConsumptionWidget } from './widgets/ConsumptionWidget';
import { BillingTrendWidget } from './widgets/BillingTrendWidget';
import { RecentBillsWidget } from './widgets/RecentBillsWidget';
import { RecentRequestsWidget } from './widgets/RecentRequestsWidget';
import { useConsumerBillDetails, useSelfServiceWidgets } from '../hook';
import { getLoginDataFromStorage } from '@shared/utils/loginUtils';
import { getRemoteUtilityId } from '@shared/utils/getUtilityId';
import { useTranslation } from 'react-i18next';


export const Landing = () => {
    const { data: widgetSettings } = useSelfServiceWidgets({ remote_utility_id: Number(getRemoteUtilityId()) });
    const { i18n } = useTranslation();

   

  const { remoteUtilityId, remoteConsumerNumber } = getLoginDataFromStorage();

  // Fetch bill data for the billing trend widget
  const { data: consumerBillData } = useConsumerBillDetails({
    remoteUtilityId: remoteUtilityId,
    remoteConsumerNumber: remoteConsumerNumber,
    fetch_last_six_records: "True",
  });

   useEffect(() => {
      if (consumerBillData) {
        const additionalData = consumerBillData?.result?.additionalData;
          
        const language = additionalData?.language || 'en';
        console.log('languageeeee',additionalData);
        i18n.changeLanguage(language);
      }
    }, [consumerBillData, i18n]);

  return (
    <div className="p-2">
      {/* 1. Greeting Section */}
      <Greeting />

      {/* 2. KPI Cards */}
      <KPIGrid />

      {/* 3. Quick Actions */}
      <QuickActionsGrid />

      {/* 4. Conditional Widgets */}
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
          {widgetSettings?.usageChart && <ConsumptionWidget />}
          {widgetSettings?.billTrendChart && <BillingTrendWidget consumerBillData={consumerBillData} />}
          {widgetSettings?.recentBills && <RecentBillsWidget />}
          {widgetSettings?.recentRequests && <RecentRequestsWidget />}
        </div>
    </div>
  );
};

export default Landing;
